import React from 'react';
import { Button } from './ui/button';
import { List, Share } from 'lucide-react';

interface BottomNavigationProps {
  currentView: 'dashboard' | 'broadcast';
  onNavigate: (view: 'dashboard' | 'broadcast') => void;
  onBroadcastClick: () => void;
}

const BottomNavigation: React.FC<BottomNavigationProps> = ({ 
  currentView, 
  onNavigate, 
  onBroadcastClick 
}) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50">
      <div className="grid grid-cols-2">
        <Button
          variant="ghost"
          className={`py-4 rounded-none ${
            currentView === 'dashboard' 
              ? 'text-blue-600 bg-blue-50' 
              : 'text-gray-600 hover:text-blue-600 hover:bg-gray-50'
          }`}
          onClick={() => onNavigate('dashboard')}
        >
          <div className="text-center">
            <List className="h-5 w-5 mx-auto mb-1" />
            <span className="text-xs block font-medium">Beranda</span>
          </div>
        </Button>
        <Button
          variant="ghost"
          className={`py-4 rounded-none ${
            currentView === 'broadcast' 
              ? 'text-blue-600 bg-blue-50' 
              : 'text-gray-600 hover:text-blue-600 hover:bg-gray-50'
          }`}
          onClick={onBroadcastClick}
        >
          <div className="text-center">
            <Share className="h-5 w-5 mx-auto mb-1" />
            <span className="text-xs block font-medium">Kirim Link</span>
          </div>
        </Button>
      </div>
    </div>
  );
};

export default BottomNavigation;